import _defineProperty from '@babel/runtime-corejs2/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs2/helpers/objectWithoutProperties';
import { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import styledSystemPropTypes from '@styled-system/prop-types';
import Box from '@locus-labs/mol-desktop-box';
import styled, { ThemeContext } from 'styled-components';
import { jsx } from 'react/jsx-runtime';

const _excluded = ["url", "alt", "logoHeight", "position"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const StyledImage = styled.img.withConfig({
  displayName: "logo__StyledImage",
  componentId: "c2riz8-0"
})(["min-height:28px;max-height:100px;width:auto;max-width:100%;"]);
const Logo = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      url,
      alt,
      logoHeight,
      position
    } = props,
    omittedProps = _objectWithoutProperties(props, _excluded);
  const themeContext = useContext(ThemeContext);
  const alignmentType = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
  };
  return /*#__PURE__*/jsx(Box, _objectSpread(_objectSpread({
    ref: ref,
    display: "flex",
    bg: themeContext.colors.widgetBackground,
    p: "20px 20px 0 20px",
    justifyContent: alignmentType[position],
    width: "320px"
  }, omittedProps), {}, {
    children: /*#__PURE__*/jsx(StyledImage, {
      src: url,
      alt: alt,
      height: logoHeight
    })
  }));
});
Logo.displayName = 'Logo';
Logo.defaultProps = {
  'data-cy': 'Logo',
  position: 'center'
};
Logo.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styledSystemPropTypes.space), styledSystemPropTypes.color), styledSystemPropTypes.background), styledSystemPropTypes.border), styledSystemPropTypes.flexbox), styledSystemPropTypes.grid), styledSystemPropTypes.layout), styledSystemPropTypes.position), styledSystemPropTypes.shadow), styledSystemPropTypes.typography), {}, {
  as: PropTypes.string,
  forwardAs: PropTypes.string,
  url: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  logoHeight: PropTypes.number,
  position: PropTypes.oneOf(['left', 'center', 'right'])
});

export default Logo;
